export default "__VITE_ASSET__FIFOLL6y__"